import { type Scene } from "three";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import Logger from "@/lib/logger.ts";
import Environment from "./Environment.ts";
import Model from "./Model.ts";

export default class World {
    readonly #model: Model;
    readonly #environment: Environment;

    constructor(scene: Scene) {
        this.#model = new Model(scene);
        this.#environment = new Environment(scene);
    }

    init = (): void => {
        Logger.info("Creating world....");
        DiagnosticsStore.collectEventLog("info", "Creating world");

        this.#model.init();
        this.#environment.init();
    };
}
